import { render, staticRenderFns } from "./ValueMarker.vue?vue&type=template&id=0a897a3f&scoped=true"
import script from "./ValueMarker.vue?vue&type=script&lang=ts"
export * from "./ValueMarker.vue?vue&type=script&lang=ts"
import style0 from "./ValueMarker.vue?vue&type=style&index=0&id=0a897a3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a897a3f",
  null
  
)

export default component.exports